{
  "Müşteriler": "Klanten",
  "musteriler": {
    "Müşteriler": "Klanten",
    "Ad": "Voornaam",
    "Soyad": "Achternaam",
    "Referans": "Referentie",
    "Cep": "Mobiel",
    "Cep 2": "Mobiel 2",
    "Meslek": "Beroep",
    "Cinsiyet": "Geslacht",
    "Kimlik No": "ID Nummer",
    "Doğum Tarihi": "Geboortedatum",
    "Email": "E-mail",
    "Email 2": "E-mail 2",
    "Adres": "Adres",
    "İl": "Provincie",
    "İlçe": "District",
    "Not": "Notitie",
    "Yetki Talep": "Autorisatie Aanvraag",
    "Telefon": "Telefoon",
    "Onay Bekleyenler": "Wachtend op goedkeuring",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Kapat": "Sluiten",
    "Durum": "Status",
    "Onsekizalti": "Onder 18",
    "Sigorta Ettiren": "Verzekeringnemer",
    "Yenile": "Vernieuwen"
  }
}
